import { render, staticRenderFns } from "./sub-award-item.vue?vue&type=template&id=05e508cc&scoped=true&"
import script from "./sub-award-item.vue?vue&type=script&lang=js&"
export * from "./sub-award-item.vue?vue&type=script&lang=js&"
import style0 from "./sub-award-item.vue?vue&type=style&index=0&id=05e508cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e508cc",
  null
  
)

export default component.exports